import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BsXCircle } from "react-icons/bs";
import TextField from '@mui/material/TextField';
import Countdown from 'react-countdown';
import { SHOW_MSISDN, SHOW_OTP, SHOW_PACKAGE, SHOW_SUCCESS } from '../../common/constant';
import { customStyles, headerContainerStyle, iconStyle, titleStyle, textStyle } from '../../common/modalStyle'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { store } from '../..';
import { setShowResultModal } from '../../actions/modal';
import { success } from '../../common/errorCode';
import MyButton from '../MyButton';
import { useTranslation } from "react-i18next";


const MyResultModal = ({ isOpenOtp, setOpenOtp, errorMessage }) => {
    const { t } = useTranslation();

    let modalReducer = useSelector((state) => state.ModalReducer);
    console.log("modalReducer MyResultModal: " + JSON.stringify(modalReducer));

    const navigate = useNavigate();

    let desField = <div></div>
    let timeField = <div></div>
    let textField = <div></div>

    let color = modalReducer.dataToModal.errorCode == success ? "green" : "red";
    function closeModal() {
        store.dispatch(setShowResultModal(false));
    }

    return (
        <div>
            <Modal
                isOpen={isOpenOtp}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Result Modal"
            >
                <div style={headerContainerStyle}>
                    <div style={iconStyle} onClick={closeModal}>
                        <BsXCircle style={{ height: "2rem", width: "2rem" }} />
                    </div>
                </div>
                <div style={titleStyle}>{t("result").toUpperCase()}</div>
                <div style={{
                    color: "black",
                    textAlign: "center",
                    marginTop: "20px"
                }}>
                    {modalReducer.dataToModal.message}
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {textField}
                </div>
                {timeField}
                <div style={{ marginTop: "20px" }}>
                </div>
                <MyButton name={"Close"} onClickButton={() => closeModal()} />
                <div style={{ marginTop: "20px" }}>
                </div>
            </Modal>
        </div>
    );
}

export default MyResultModal;